import React from 'react';
import { PreAuthentificationPage } from './preAuthentificationPage';

export function LoadingScreen(): JSX.Element {
  return (
    <PreAuthentificationPage
      header="Loading data"
      paragraph="Please wait while the data is being loaded."
    />
  );
}
